import React from "react";

const Loader = ({ text = "Loading...", height = 200 }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height }}
    >
      <div className="spinner-border text-primary me-2" role="status">
        <span className="visually-hidden">{text}</span>
      </div>
      <span>{text}</span>
    </div>
  );
};

export default Loader;
